import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'react-final-form';
import { AppState } from 'services/types';
// @ts-ignore
import { RenderDropdown } from 'forms';
import { selectOptions } from './selectors';

interface OwnProps {
    validate?: any;
    label?: string;
    placeholder?: string;
    name: string;
}

interface ConnectedProps {
    options?: {
        key: number;
        text: string;
        value: number;
    }[];
}

type Props = OwnProps & ConnectedProps;

export class PeopleDropdown extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { validate, label, placeholder, options, name } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                validate={validate}
                label={label || 'Person'}
                placeholder={placeholder || 'Select a person'}
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                options={options}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    options: selectOptions
});

export default connect(mapStateToProps)(PeopleDropdown);
